// plan-05 S06: paint mode — cycle 0-6 maturity per click

import type { HexGrid } from './geometry'
import { MATURITY_COLORS } from './render'

const PAINT_MAX = 6

// precomputed paint colors — warm ramp for paint mode (different from run colors)
const PAINT_FILLS: string[] = []
const PAINT_STROKES: string[] = []
for (let v = 0; v <= PAINT_MAX; v++) {
  if (v === 0) {
    PAINT_FILLS.push('rgba(0, 90, 0, 0.10)')
    PAINT_STROKES.push('rgba(0, 90, 0, 0.28)')
  } else {
    // use the same ramp as maturity colors
    PAINT_FILLS.push(MATURITY_COLORS[Math.min(v, 6)].fill)
    PAINT_STROKES.push(MATURITY_COLORS[Math.min(v, 6)].stroke)
  }
}

export interface PaintState {
  paintHits: number[]
  paintedCount: number
  paintMode: boolean
}

export function createPaintState(total: number): PaintState {
  return {
    paintHits: new Array(total).fill(0),
    paintedCount: 0,
    paintMode: false,
  }
}

export function cyclePaint(state: PaintState, seqNum: number): number {
  const was = state.paintHits[seqNum]
  const now = (was + 1) % (PAINT_MAX + 1)
  state.paintHits[seqNum] = now

  if (was === 0 && now > 0) state.paintedCount++
  else if (was > 0 && now === 0) state.paintedCount--

  return now
}

export function applyPaintVisuals(grid: HexGrid, state: PaintState): void {
  for (const h of grid.ordered) {
    const v = state.paintHits[h.seqNum]
    h.poly!.setAttribute('fill', PAINT_FILLS[v])
    h.poly!.setAttribute('stroke', PAINT_STROKES[v])
  }
}

export function clearPaint(state: PaintState, total: number): void {
  state.paintHits = new Array(total).fill(0)
  state.paintedCount = 0
}

export { PAINT_MAX, PAINT_FILLS, PAINT_STROKES }
